import { render, staticRenderFns } from "./deprecated_modal.vue?vue&type=template&id=5ed6b48b&"
import script from "./deprecated_modal.vue?vue&type=script&lang=js&"
export * from "./deprecated_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports